import { useDispatch } from "react-redux";
import error404 from "../../assets/image/error404.png"
import error500 from "../../assets/image/error500.jpg"
import { handleErrorState } from "../../HandleSlice/HandleSlice";
import { ImCancelCircle } from "react-icons/im";
import { useEffect } from "react";
const Error = (props) => {
    const dispatch = useDispatch()
    
useEffect(()=>{
    document.body.addEventListener("click", (event) => {
        if (event.target.matches(".blurPage"))
        closeModal()
    })
},[])

    function closeModal() {
        dispatch(handleErrorState(""))
    }
    return (
        <>
            {props.error === 404 ? <div className="blurPage w-full fixed h-full flex justify-center items-center bg-[#00000057] z-[999999999999999]">
                <div className="bg-white w-[60%] relative rounded-2xl ">
                <ImCancelCircle onClick={closeModal} className="text-red-500 text-[24px] absolute top-4 right-4 cursor-pointer" />
                    <img src={error404} alt="erorr404" className="w-[70%] m-auto" />
                </div>
            </div> : props.error === 500 ? 
            <div className="blurPage w-full fixed h-full flex justify-center items-center bg-[#00000057] z-[999999999999999]">
                <div className="bg-white w-[60%] relative rounded-2xl">
                <ImCancelCircle onClick={closeModal} className="text-red-500 text-[24px] absolute top-4 right-4 cursor-pointer" />
                    <img src={error500} alt="erorr500" className="w-[70%] m-auto" />
                </div>
            </div>: 
            <div className="blurPage w-full fixed h-full flex justify-center items-center bg-[#00000057] z-[999999999999999]">
                <div className="bg-white w-[60%] relative rounded-2xl">
                <ImCancelCircle onClick={closeModal} className="text-red-500 text-[24px] absolute top-4 right-4 cursor-pointer" />
                    <span className="m-auto text-[32px] font-bold">error {props.error}</span>
                </div>
            </div>
            }
        </>
    );
}

export default Error;